import { render, staticRenderFns } from "./Auftraege_Rechnung.vue?vue&type=template&id=ca4cf1a8&scoped=true"
import script from "./Auftraege_Rechnung.vue?vue&type=script&lang=js"
export * from "./Auftraege_Rechnung.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/auftragsbuch/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca4cf1a8",
  null
  
)

export default component.exports